import Grid from '@material-ui/core/Grid';
import { Card, CardContent, Box, Typography } from '@material-ui/core';
import { subContentColor, mainContentColor } from '../../components/lib/Color';
import BrushIcon from '@material-ui/icons/Brush';
import AssetPositionArea from "./AssetPositionArea";
import { MemberType, PositionType, PlayerType } from '../Type/TeamType';
import { EffectSkilePositionType, OpenProps } from "../assetSettingModal/hooks/AssetSettingModalType";

type Props = {
    member: MemberType,
    teamPosition: PositionType,
    teamPlayer: PlayerType,
    openTeamAssetSettingModal: ({ mode, player, position }: OpenProps) => void,
    setEffectSkilePositionTop: (player: PlayerType, position: PositionType) => void,
    setEffectSkilePositionBottom: (player: PlayerType, position: PositionType) => void
}
const SettingConfirmAreaRow = ({
    member,
    teamPosition,
    teamPlayer,
    openTeamAssetSettingModal,
    setEffectSkilePositionTop,
    setEffectSkilePositionBottom,
}: Props) => {
    const minBoxWidth = 300;
    const { hero, leftExtension, rightExtension, artSkill } = member;

    const makeParameter = (
        heroParameter: number | undefined,
        leftExtensionParameter: number | undefined,
        rightExtensionParameter: number | undefined
    ) => {
        let parameter = 0;
        if (heroParameter) parameter += heroParameter
        if (leftExtensionParameter) parameter += leftExtensionParameter
        if (rightExtensionParameter) parameter += rightExtensionParameter
        return parameter
    }

    return (
        <Grid item xs={4} style={{
            textAlign: 'center',
            justifyContent: 'center',
            alignContent: 'center',
        }}>
            <Card style={{ background: subContentColor }}>
                <CardContent >
                    <Box minWidth={minBoxWidth} >
                        <img
                            src={`/images/extensions/${leftExtension?.id}.png`}
                            style={{ width: 64, height: 64, background: mainContentColor, marginBottom: "30px", marginRight: "10px" }}
                            onClick={() => openTeamAssetSettingModal(
                                {
                                    mode: "ExtensionLeft",
                                    player: teamPlayer,
                                    position: teamPosition
                                }
                            )}
                        />
                        <img
                            src={`/images/heroes/${hero?.id}.png`}
                            style={{ width: 128, height: 128, background: mainContentColor }}
                            onClick={() => openTeamAssetSettingModal(
                                {
                                    mode: "Hero",
                                    player: teamPlayer,
                                    position: teamPosition
                                }
                            )}
                        />
                        <img
                            src={`/images/extensions/${rightExtension?.id}.png`}
                            style={{ width: 64, height: 64, background: mainContentColor, marginBottom: "30px", marginLeft: "10px" }}
                            onClick={() => openTeamAssetSettingModal(
                                {
                                    mode: "ExtensionRight",
                                    player: teamPlayer,
                                    position: teamPosition
                                }
                            )}
                        />
                    </Box>
                    <Box style={{
                        marginTop: 10,
                        background: mainContentColor,
                    }}
                        onClick={() => openTeamAssetSettingModal(
                            {
                                mode: "ArtSkill",
                                player: teamPlayer,
                                position: teamPosition
                            }
                        )}
                    >
                        <Typography variant="h5" style={{ color: "white", marginLeft: "10px", top: "50%", position: "relative", textAlign: "left" }}><BrushIcon />{artSkill?.name}</Typography>
                        <Typography variant="h6" style={{ color: "white", marginLeft: "10px", top: "50%", position: "relative", textAlign: "left" }}>{artSkill?.effect}</Typography>
                    </Box>
                    <Box minWidth={minBoxWidth}>
                        <Typography display="inline" variant="h5" style={{ color: "white", marginLeft: "10px", top: "50%", position: "relative", textAlign: "left" }}>HP</Typography>
                        <Typography display="inline" variant="h5" style={{ color: "white", marginLeft: "10px", top: "50%", position: "relative", textAlign: "left" }}>HY</Typography>
                        <Typography display="inline" variant="h5" style={{ color: "white", marginLeft: "10px", top: "50%", position: "relative", textAlign: "left" }}>INT</Typography>
                        <Typography display="inline" variant="h5" style={{ color: "white", marginLeft: "10px", top: "50%", position: "relative", textAlign: "left" }}>AGI</Typography>
                    </Box>
                    <Box minWidth={minBoxWidth}>
                        <Typography display="inline" variant="h5" style={{ color: "white", marginLeft: "10px", top: "50%", position: "relative", textAlign: "left", background: mainContentColor }}>
                            {makeParameter(
                                hero?.hp,
                                leftExtension?.hp,
                                rightExtension?.hp
                            )}
                        </Typography>
                        <Typography display="inline" variant="h5" style={{ color: "white", marginLeft: "10px", top: "50%", position: "relative", textAlign: "left", background: mainContentColor }}>
                            {makeParameter(
                                hero?.phy,
                                leftExtension?.phy,
                                rightExtension?.phy
                            )}
                        </Typography>
                        <Typography display="inline" variant="h5" style={{ color: "white", marginLeft: "10px", top: "50%", position: "relative", textAlign: "left", background: mainContentColor }}>
                            {makeParameter(
                                hero?.int,
                                leftExtension?.int,
                                rightExtension?.int
                            )}
                        </Typography>
                        <Typography display="inline" variant="h5" style={{ color: "white", marginLeft: "10px", top: "50%", position: "relative", textAlign: "left", background: mainContentColor }}>
                            {makeParameter(
                                hero?.agi,
                                leftExtension?.agi,
                                rightExtension?.agi
                            )}
                        </Typography>
                    </Box>
                    <AssetPositionArea member={member}
                        onAssetPositionChangeButtonTopClick={() => setEffectSkilePositionTop(teamPlayer, teamPosition)}
                        onAssetPositionChangeButtonBottomClick={() => setEffectSkilePositionBottom(teamPlayer, teamPosition)}
                    />
                </CardContent>
            </Card>

        </Grid>
    );
}

export default SettingConfirmAreaRow;
